<template>
    <div class="video-response">
        <div v-if="response != null && response[0] && response[0].value" class="video answer">
            <el-timeline :active="timeLineArr.length" align-center>
                <el-timeline-item v-for="(timeObj, index) in timeLineArr" 
                    :key="index"
                    :timestamp="formatTime(timeObj.value, true)"
                    size="large"
                    :type="timeObj.type"
                    :icon="timeObj.icon">
                    {{ timeObj.title }}
                </el-timeline-item>
            </el-timeline>
        </div>
        <div v-else class="no-answer inl-blk">
            <span>Not Answered</span>
        </div>
    </div>
</template>

<script>

import Icons from '../icon'
import formatDateTime from '@/module/util/format-date-time'
import formatTime from '@/module/util/format-time'

export default {   
    name: 'video-consent-partial',

    props: {
        // Content object for this question
		question: {
			type: Object,
			required: true
		},
		response: {
			type: Array
		},
	},

    methods: {
        formatDateTime,
        formatTime
    },

    computed: {
        /**
         * Returns the array of timeLine objects with starting, pause and end time
         */
        timeLineArr() {
            const timeLineArr = []
            if(Array.isArray(this.response) && this.response.length > 0) {
                const meta = this.response[0].meta
                timeLineArr.push({ value: meta.face_recording_start, title: 'Recording Start', icon: 'el-icon-user', type: 'primary' })
                if(meta.video_paused_times && meta.video_paused_times.length > 0) {
                    meta.video_paused_times.forEach((time) => {
                        timeLineArr.push({ value: time, title: `Video Paused`, icon: 'el-icon-video-pause', type: 'info' })
                        // Find the first timestamp in `meta.video_resume_times` that is greater than `time`
                        const resumeTime = meta.video_resume_times.find((resumeTime) => resumeTime > time)
                        if(resumeTime) {
                            timeLineArr.push({ value: resumeTime, title: `Video Resumed`, icon: 'el-icon-video-play', type: 'info' })
                        }
                    })
                    
                }
                timeLineArr.push({ value: meta.face_recording_end, title: 'Recording End', icon: 'el-icon-check', type: 'success' })
            }
            return timeLineArr
        }
    },

    components: {
        ...Icons
    }
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.watched-date {
    color: #833E93;
    font-size: 13px;
    font-weight: bold;
}
.watch-video {
    text-decoration: underline;
    color: #666666;
}

.inl-blk {
    display: inline-block;
}
.open-icon {
    margin-left: 10px;
    height: 26px;
    width: 26px;
    margin-top: 9px;
}
.video-response {
    .answer {
        display: inline-flex;
        justify-content: start;
        align-items: center;
        margin-top: -10px;
        .answered-text {
            // padding-top: 5px;

            .weighted-middot {
                font-size: 2em;
                position: relative;
                top: 2px;
            }
        }
    }
}
</style>
